export type { ProductCardProps } from './ProductCard';
export { default } from './ProductCard';
